module.exports = __webpack_public_path__ + "img/wilkommen.cf744f1c.png";